import { MENSAJE_EXITO, MENSAJE_BORRAR } from "./type";
import uuid from "uuid";

export const mensaje = (msg, alertaTipo) => async dispatch => {
  const id = uuid.v4();
  dispatch({ type: MENSAJE_EXITO, payload: { id, alertaTipo, msg } });

  setTimeout(() => dispatch({ type: MENSAJE_BORRAR, payload: id }), 5000);
};
